// extracted by mini-css-extract-plugin
module.exports = {"root":"RightColumn_root__2N_-G"};